import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

export const FAILURE_DIAGNOSTICS_AVAILABILITY_QUERY_KEY = 'failureDiagnosticsAvailability';

export function useGetFailureDiagnosticsAvailability() {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery({
    queryKey: [FAILURE_DIAGNOSTICS_AVAILABILITY_QUERY_KEY, { tenantId }],
    queryFn: async () => api.assets.getFailureDiagnosticsAvailability(tenantId),
    select: data => data.data,
    enabled: !!tenantId,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
